module.exports = __webpack_public_path__ + "assets/aa141795abb5d9624552214050274aea.png";